import { Controller } from "@hotwired/stimulus"

// Populates the read-only analytical values display in the DDT form
// from the data carried by the selected lot <option>, and shows the
// lot residual quantity hint next to the weight field.
export default class extends Controller {
  static targets = ["lotSelect", "value", "residual"]

  connect() {
    this.update()
  }

  update() {
    const option = this.lotSelectTarget.selectedOptions[0]
    let data = {}
    if (option && option.dataset.analytical) {
      try {
        data = JSON.parse(option.dataset.analytical)
      } catch {
        data = {}
      }
    }

    this.valueTargets.forEach((el) => {
      const key = el.dataset.field
      const raw = data[key]
      el.textContent = raw === null || raw === undefined || raw === "" ? "—" : String(raw)
    })

    if (this.hasResidualTarget) {
      const residual = option ? option.dataset.residual : null
      this.residualTarget.textContent =
        residual === null || residual === undefined || residual === "" ? "" : `${residual} t`
    }
  }
}
